import React from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './HowItsWorkBlock.module.scss';
import { CollapsableInfoBox } from '../../../../shared/components/ui-components';
import { RichTextViewer } from '../../../../shared/features/rich-text';
import { ScoringRuleType } from '../../../constants/scoringRule';
import { getHumanizeScoringRule } from '../../../utils/getHumanizeScoringRule/getHumanizeScoringRule';

type HowItsWorkBlockProps = {
  defaultOpen: boolean;
  aboutInfo: string | null;
  additionalInfo: string | null;
  scoringRules: ScoringRuleType | null;
};

const HowItsWorkBlock = ({
  defaultOpen,
  aboutInfo,
  additionalInfo,
  scoringRules,
}: HowItsWorkBlockProps) => {
  return (
    <CollapsableInfoBox
      title="How it Works?"
      defaultOpen={defaultOpen}
      contentClassName={classes.container}
      customMargin
    >
      <TitleWithDescription
        className={classes.challengeType}
        title="Challenge Type:"
        description={scoringRules ? getHumanizeScoringRule(scoringRules) : '-'}
        titleFont="body-14-bold"
        direction="row"
        descriptionColor="main-black"
        withoutGap
      />
      <RichTextViewer content={aboutInfo || '-'} />
      <TitleWithDescription
        title="What you'll need"
        description={<RichTextViewer content={additionalInfo || '-'} />}
        titleFont="body-14-bold"
        descriptionColor="main-black"
      />
    </CollapsableInfoBox>
  );
};

export { HowItsWorkBlock };
